import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse} from '../../../../domain';
import {arraySwapItems, HttpPromiseState, SaveStateHolder} from '../../../../lib/helpers';

export class ReorderBlocksStore implements SaveStateHolder {
  @observable
  readonly blockIds: number[];

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly pushableBlockId: number,
              blockIds: number[]) {
    makeObservable(this);
    this.blockIds = blockIds;
    this.save = null;
  }

  @action
  swap(index1: number, index2: number) {
    arraySwapItems(this.blockIds, index1, index2);
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    const reordered = this.blockIds.slice();
    this.save = contentLoaders.x7pushableBlock.orderChildren(this.pushableBlockId, reordered);
  }
}
